import TomorrowPlanType from 'types/enums/TomorrowPlanType';
import Product from 'types/models/Product';
import TomorrowPlan from 'types/models/TomorrowPlan';

export const productIsEmpty = (product: Product): boolean => {
  if (!product.isClothing && !product.stock) {
    return true;
  }

  if (product.isClothing) {
    const allClothingSizeStoksAreEmpty = product.clothingSizeStocks.every(({ stock }) => stock === 0);
    return allClothingSizeStoksAreEmpty;
  }

  return false;
};

export const productIsValidForCurrentTomorrowUser = (
  productTomorrowPlan?: TomorrowPlan[],
  userIsTomorrowMasterPartner?: boolean,
  userTomorrowPlanId?: TomorrowPlanType,
): boolean => {
  if (userIsTomorrowMasterPartner) return true;
  const plans = productTomorrowPlan?.map(({ id }) => id);
  if (!userTomorrowPlanId || !plans || !plans.length) return false;
  const underAgeUserShouldNotSeeLegalAgeProduct =
    !userIsTomorrowMasterPartner &&
    userTomorrowPlanId === TomorrowPlanType.UnderAge &&
    !plans?.includes(TomorrowPlanType.UnderAge);
  if (underAgeUserShouldNotSeeLegalAgeProduct) return false;
  return plans.includes(userTomorrowPlanId);
};
